import TechnolivePopup from "../promotions/TechnolivePopup";
import AnnouncementBar from "../promotions/AnnouncementBar";
import StoreChat from "../chat/StoreChat";
import MobileContactBar from "../Components/MobileContactBar";
import Analytics from "../analytics/Analytics";
import { Outlet, ScrollRestoration } from "react-router-dom";
import { Suspense } from "react";
import { Header, Footer } from "../Pages/index";
import { useLocation } from "react-router-dom";
import { usePageMeta } from "../seo/pageMeta";
const RootLayout = () => {
  const location = useLocation();
  usePageMeta();

  // Correct use of the conditional rendering based on the pathname
  // Also corrected pathname property

  return (
    <>
      <AnnouncementBar />
      <Header />
      <Suspense fallback={<main className="page-loading" role="status" aria-live="polite">Loading…</main>}>
        <Outlet />
      </Suspense>
      {location.pathname !== "/register" &&
      location.pathname !== "/login" &&
      location.pathname !== "/payment" ? (
        <Footer />
      ) : null}
      <Analytics />
      <StoreChat />
      <MobileContactBar />
      <TechnolivePopup />
      {/* New pages open at the top (or at their #section); Back returns to
          where the customer was. Some pages kept the previous page's scroll. */}
      <ScrollRestoration />
    </>
  );
};

export default RootLayout;
